module.exports = __webpack_public_path__ + "static/media/MediumRisk.dfded078.svg";